import {_User} from "./_User";

export const UsersModuleEventsAPI = {
    User: _User
}